const scrollToMap = () => {}

window.setTimeout(() => {
  scrollToMap()
}, 500)
